
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/advancedStylePanel/templates/ScrollResetButton/scrollResetButton.scss.css.virtualfile';
        module.exports = {"scrollBtnContainer":"_scrollBtnContainer_afmla_1"};